/**
 * Created by m.igrachev on 8/3/2017.
 */
import React from "react";
import PropTypes from "prop-types";
import StringUtil from "@tinqin/tinqin-utils/src/string";
import documentedProps from "./documentation/ParagraphDocumentedProps";

import("./Paragraph.less");

export default class Paragraph extends React.Component {
    buildContent() {
        let toReplace = {};
        let placeholders = [];
        React.Children.forEach(this.props.children, (item) => {
            if (!React.isValidElement(item)) return;
            let placeholder = item.props.placeholder;
            if (placeholder && item.props.children) {
                toReplace[placeholder] = item.props.children;
                placeholders.push(placeholder);
            }
        });

        let placeholdersArray = StringUtil.splitWithPlaceholders(this.props.text, placeholders);

        let result = [];
        placeholdersArray.forEach((item, outerIndex) => {
            if (toReplace[item] !== undefined) {
                result.push(
                    React.cloneElement(toReplace[item], {
                        key: outerIndex
                    })
                );
            } else if (item && item.split) {
                //Manage new line character in the string!
                let itemSplit = item.split("\n");
                itemSplit.forEach((fraction, innerIndex) => {
                    if (fraction) {
                        //Paragraph lines that have tabulation are been covered here.
                        if (fraction.indexOf("\t") !== -1) {
                            let tabsResult = [];
                            let tabStyle = {
                                width: "15px",
                                display: "inline-block"
                            };
                            let tabulationSplit = fraction.split("\t");
                            let lastTabulation = tabulationSplit.length - 1;
                            //A span with padding is used to replace the \t from then sting
                            let tabulator = <span style={tabStyle} />;

                            tabulationSplit.forEach((tabItem, index) => {
                                if (tabItem) {
                                    tabsResult.push(tabItem);
                                    if (index < lastTabulation) {
                                        tabsResult.push(tabulator);
                                    }
                                } else {
                                    tabsResult.push(tabulator);
                                }
                            });

                            fraction = tabsResult;
                        }

                        //respect the ["", " asd ", " sdf"] case of "\n asd \n sdf".
                        //If there is a tabulation then the "fraction" is an array object, that is why
                        //a concat method is used here instead of push.
                        result = result.concat(fraction);
                    }
                    if (innerIndex < itemSplit.length - 1) {
                        result.push(<br key={"br-" + outerIndex + innerIndex} />);
                    }
                });
            }
        });

        return result;
    }

    render() {
        let content = this.buildContent();
        let alignment = this.props.alignment || "left";
        let paragraphClass = "tq-paragraph tq-text-" + alignment;
        return (
            <div className={this.props.extraClasses} data-tq-id={this.props.dataTqId}>
                <p className={paragraphClass}>{content}</p>
            </div>
        );
    }
}

Paragraph.displayName = "Paragraph";

Paragraph.propTypes = {
    extraClasses: PropTypes.string,
    text: PropTypes.string.isRequired,
    dataTqId: PropTypes.string,
    alignment: PropTypes.oneOf(["left", "right", "center", "justify"])
};

Paragraph.documentedProps = documentedProps;
